import React, { useState, useEffect } from "react";
import {useSelector} from "react-redux";


const ProfileHeaderSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const headerslider = useSelector((state) => state.fetchUser?.user?.customBrandingLabels) || [];

  // console.log(headerslider);

  const nextText = () => {
    if (isAnimating) return;
    if(headerslider?.length > 0) {
      const next = (currentIndex + 1) % headerslider?.length;
      setNextIndex(next);
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentIndex(next);
        setNextIndex(null);
        setIsAnimating(false);
      }, 600);
    }
  };

  const prevTextHandler = () => {
    if (isAnimating) return;
    if(headerslider?.length > 0) {
      const prev = currentIndex === 0 ? headerslider?.length - 1 : currentIndex - 1;
      setNextIndex(prev);
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentIndex(prev);
        setNextIndex(null);
        setIsAnimating(false);
      }, 600);
    }
  };

  useEffect(() => {
    const interval = setInterval(nextText, 2000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  return (
      headerslider?.length > 0 && (
      <div className="header-slider">
        {/* Current slide */}
        <div className={`div-slider fontclass ${isAnimating ? 'slide-out' : ''}`}>
          <button className="slider-btn left" onClick={() => prevTextHandler}>&lt;</button>
          {headerslider[currentIndex] &&
          <div className="slider-text fontclass">{headerslider[currentIndex].text}</div>
          }
          <button className="slider-btn right" onClick={() => nextText}>&gt;</button>
        </div>

        {/* Next slide */}
        {isAnimating && nextIndex !== null && (
            <div className="div-slider slide-in">
              <button className="slider-btn left" onClick={() => prevTextHandler}>&lt;</button>
              {headerslider[nextIndex] &&
              <div className="slider-text">{headerslider[nextIndex].text}</div>
              }
              <button className="slider-btn right" onClick={() => nextText}>&gt;</button>
            </div>
        )}
      </div>
      )
  );
};

export default ProfileHeaderSlider;